import { createRouter, createWebHistory } from 'vue-router';
import PublicLayout from '@/layouts/PublicLayout.vue';
import PortalLayout from '@/layouts/PortalLayout.vue';
import { authStore } from '@/stores/auth';

const router=createRouter({
  history:createWebHistory(),
  scrollBehavior:()=>({top:0}),
  routes:[
    {path:'/',component:PublicLayout,children:[
      {path:'',component:()=>import('@/views/MarketplaceHome.vue')},
      {path:'companies',component:()=>import('@/views/CompaniesView.vue')},
      {path:'companies/:slug',component:()=>import('@/views/CompanyDetailView.vue')},
      {path:'jobs',component:()=>import('@/views/JobsView.vue')},
      {path:'jobs/:slug',component:()=>import('@/views/JobDetailView.vue')},
      {path:'help',component:()=>import('@/views/HelpView.vue')},
      {path:'auth',component:()=>import('@/views/AuthView.vue')},
    ]},
    {path:'/portal',component:PortalLayout,meta:{requiresAuth:true,role:'candidate'},children:[
      {path:'',component:()=>import('@/views/candidate/CandidateDashboard.vue'),meta:{title:'Beranda Kandidat'}},
      {path:'applications',component:()=>import('@/views/candidate/CandidateApplications.vue'),meta:{title:'Lamaran Saya'}},
      {path:'assessments',component:()=>import('@/views/candidate/CandidateAssessments.vue'),meta:{title:'Assessment Profile'}},
      {path:'profile',component:()=>import('@/views/candidate/CandidateProfile.vue'),meta:{title:'Profil Saya'}},
    ]},
    {path:'/tenant',component:PortalLayout,meta:{requiresAuth:true,area:'tenant'},children:[
      {path:'',component:()=>import('@/views/tenant/TenantDashboard.vue'),meta:{title:'Dashboard Rekrutmen'}},
      {path:'jobs',component:()=>import('@/views/tenant/TenantJobs.vue'),meta:{title:'Lowongan & Batch'}},
      {path:'pipeline',component:()=>import('@/views/tenant/TenantPipeline.vue'),meta:{title:'Pipeline Kandidat'}},
      {path:'assessments',component:()=>import('@/views/tenant/TenantAssessments.vue'),meta:{title:'Assessment & Requirement'}},
      {path:'team',component:()=>import('@/views/tenant/TenantTeam.vue'),meta:{title:'Hiring Team'}},
    ]},
    {path:'/admin',component:PortalLayout,meta:{requiresAuth:true,role:'platform_admin'},children:[
      {path:'',component:()=>import('@/views/admin/AdminDashboard.vue'),meta:{title:'Platform Dashboard'}},
      {path:'tenants',component:()=>import('@/views/admin/AdminTenants.vue'),meta:{title:'Tenant Management'}},
      {path:'integration',component:()=>import('@/views/admin/AdminIntegration.vue'),meta:{title:'Integrasi Psychometric'}},
    ]},
    {path:'/:pathMatch(.*)*',component:()=>import('@/views/NotFound.vue')},
  ],
});

router.beforeEach(to=>{
  if(!to.meta.requiresAuth)return true;
  if(!authStore.isAuthenticated.value)return {path:'/auth',query:{redirect:to.fullPath}};
  const role=authStore.role.value;
  if(to.meta.role && role!==to.meta.role){
    if(role==='platform_admin')return '/admin';
    if(role==='candidate')return '/portal';
    return '/tenant';
  }
  if(to.meta.area==='tenant' && !['hr','tenant_admin','hiring_team'].includes(role))return role==='platform_admin'?'/admin':'/portal';
  return true;
});

export default router;
